var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.373047,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E8E7E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 10.368C14.0232 10.368 12.4207 11.9705 12.4207 13.9472C12.4207 15.9239 14.0232 17.5263 15.9999 17.5263C17.9766 17.5263 19.5791 15.9239 19.5791 13.9472C19.5791 11.9705 17.9766 10.368 15.9999 10.368ZM11.0874 13.9472C11.0874 11.2341 13.2868 9.03467 15.9999 9.03467C18.713 9.03467 20.9124 11.2341 20.9124 13.9472C20.9124 16.6603 18.713 18.8597 15.9999 18.8597C13.2868 18.8597 11.0874 16.6603 11.0874 13.9472Z",
    fill: "#0F0C0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4755 19.3077C18.8397 19.2534 19.1789 19.5046 19.2331 19.8688L19.6919 22.947C19.7299 23.2021 19.6173 23.4563 19.4029 23.5996C19.1885 23.7429 18.9106 23.7496 18.6895 23.6169L15.9997 22.0031L13.31 23.6169C13.0888 23.7496 12.8109 23.7429 12.5965 23.5995C12.3821 23.4562 12.2695 23.202 12.3076 22.9469L12.7663 19.8725C12.8206 19.5083 13.1599 19.2571 13.5241 19.3115C13.8882 19.3658 14.1394 19.7051 14.085 20.0692L13.8347 21.7472L15.6567 20.654C15.8678 20.5273 16.1316 20.5273 16.3427 20.654L18.165 21.7474L17.9144 20.0653C17.8601 19.7011 18.1113 19.3619 18.4755 19.3077Z",
    fill: "#0F0C0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditsIcon);
export default __webpack_public_path__ + "static/media/CreditsIcon.b884c9bcd691adb3ab872a095d54c6df.svg";
export { ForwardRef as ReactComponent };